<template>
	<div class="p-0 m-0">
		<ToastPrime position="bottom-left"/>
		<div class="row mt-1">
			<div class="col-12 d-flex align-items-center justify-content-center" style="gap: 10px;">
				<!-- Draft path: Back to Draft / Save to Draft + Send -->
				<button v-if="showSaveDraftButton" type="button" class="btn btn-sm btn-primary" :disabled="isLoadingSaveDraft || isLoadingCreate || isLoadingSaveDraftStay" @click="saveDraft">
					<span v-if="isLoadingSaveDraft"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i :class="isDraftStatus ? 'fas fa-list me-2' : 'fas fa-save me-2'"></i>{{ saveDraftLabel }}</span>
				</button>
				<!--isSpecialType = 'flag-unflag', 'block-unblock', 'mrp', 'update-price', 'mass-update-mrp' -->
				<button v-if="showSaveDraftStayButton" type="button" class="btn btn-sm btn-secondary" :disabled="isLoadingSaveDraft || isLoadingCreate || isLoadingSaveDraftStay" @click="saveDraftStay">
					<span v-if="isLoadingSaveDraftStay"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-save me-2"></i>Save Draft</span>
				</button>
				<button v-if="showSendButton" type="button" class="btn btn-sm btn-success" :disabled="isLoadingSaveDraft || isLoadingCreate || isLoadingSaveDraftStay || !hasMcrItems" @click="send()">
					<span v-if="isLoadingCreate"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-paper-plane me-2"></i>Send</span>
				</button>
				<!-- My Task path (Cataloguer): Reject + Send Back + Approve + Save -->
				<button v-if="showRejectButton" type="button" class="btn btn-sm btn-danger" :disabled="isLoadingSendBack || isLoadingApprove || isLoadingReject" data-bs-toggle="modal" data-bs-target="#modalFooterMcr" @click="openFooterModal('reject')">
					<span v-if="isLoadingReject"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-times me-2"></i>Reject</span>
				</button>
				<button v-if="showSendBackButton" type="button" class="btn btn-sm btn-warning text-white" :disabled="isLoadingSendBack || isLoadingApprove || isLoadingReject" data-bs-toggle="modal" data-bs-target="#modalFooterMcr" @click="openFooterModal('sendBack')">
					<span v-if="isLoadingSendBack"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-undo me-2"></i>Send Back</span>
				</button>
				<button v-if="showApproveButton" type="button" class="btn btn-sm btn-success" :disabled="isLoadingSendBack || isLoadingApprove || isLoadingReject" @click="openFooterModal('approve')">
					<span v-if="isLoadingApprove"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-check me-2"></i>Approve</span>
				</button>
				<button v-if="showSaveDraftAntamButton" type="button" class="btn btn-sm btn-secondary" :disabled="isLoadingSaveDraftFormUserAntam || !selectedMcrItem || isLoadingSaveDraft || isLoadingApprove || isLoadingReject || isLoadingSendBack" @click="saveDraftPeritemFormUserAntam">
					<span v-if="isLoadingSaveDraftFormUserAntam"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-save me-2"></i>Save</span>
				</button>
				<button v-if="showSaveButtonForCataloguer" type="button" class="btn btn-sm btn-primary" :disabled="!selectedMcrItem || isLoadingSaveDraft || isLoadingApprove || isLoadingReject || isLoadingSendBack" @click="saveCatalog">
					<span v-if="isLoadingSaveDraft"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-save me-2"></i>Save</span>
				</button>
			</div>
		</div>
	</div>

	<!-- Modal Footer (Reject / Send Back / Approve) -->
	<div id="modalFooterMcr" class="modal fade" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">{{ modalFooter.title }}</h5>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label">Note <span v-if="['sendBack', 'reject'].includes(modalFooter.action)" class="text-danger">*</span></label>
						<textarea v-model="modalFooter.note" class="form-control" placeholder="Write the note" rows="4"
							:class="modalFooter.errorMessage['note'] && !modalFooter.note ? 'border-danger' : ''"></textarea>
						<div v-if="modalFooter.errorMessage['note'] && !modalFooter.note" class="text-danger text-sm">
							{{ modalFooter.errorMessage['note'] }}
						</div>
					</div>
					<template v-if="requiresSapCredentials && modalFooter.action == 'approve'">
						<div class="mb-3">
							<label class="form-label">Username SAP <span class="text-danger">*</span></label>
							<InputText v-model="modalFooter.username" placeholder="Enter SAP Username" size="small" fluid />
						</div>
						<div class="mb-3">
							<label class="form-label">Password SAP <span class="text-danger">*</span></label>
							<Password v-model="modalFooter.password" placeholder="Enter SAP Password" :toggleMask="true" size="small" :feedback="false" fluid />
						</div>
					</template>
				</div>
				<div class="modal-footer">
					<button ref="closeModalFooterMcr" type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModal">Close</button>
					<button type="button" class="btn btn-primary text-white" :disabled="isModalActionDisabled || isLoadingSendBack || isLoadingReject || isLoadingApprove" @click="modalAction">
						<span v-if="isLoadingSendBack || isLoadingReject || isLoadingApprove">
							<i class="fas fa-spinner fa-spin"></i>&nbsp;Please wait
						</span>
						<span v-else>{{ modalFooter.action === 'sendBack' ? 'Send Back' : modalFooter.action === 'reject' ? 'Reject' : 'Approve' }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import api from "@/helpers/api";
import cataloguerFormService from '@/services/materialCatalogingRequest/cataloguerFormService';
import flagUnflagFormService from '@/services/materialCatalogingRequest/flagUnflagFormService';
import blockUnblockFormService from '@/services/materialCatalogingRequest/blockUnblockFormService';
import mrpFormService from '@/services/materialCatalogingRequest/mrpFormService';
import massUpdateMrpFormService from '@/services/materialCatalogingRequest/massUpdateMrpFormService';
import extendFormService from '@/services/materialCatalogingRequest/extendFormService';
import woApprovalService from '@/services/dashboards/woApprovalService';
import { buildDynamicRulesForItem, buildAntamDraftRulesForItem, validateMcrItemCore, normalizeItemPayload, isCatFieldEmpty } from '@/views/materialCatalogRequest/modules/cataloguer/helperMcrFooter';
import userFormService from '@/services/materialCatalogingRequest/userFormService';
import manageAccountService from '@/services/manageAccount/manageAccountService';

export default {
	data() {
		return {
			clientCode: '',
			companyCode: '',
			technicalReviewerOptionsPromise: null,
			isLoadingSaveDraft: false,
			isLoadingSaveDraftStay: false,
			isLoadingCreate: false,
			isLoadingSendBack: false,
			isLoadingReject: false,
			isLoadingApprove: false,
			isLoadingSaveDraftFormUserAntam: false,
			modalFooter: {
				title: "",
				note: "",
				errorMessage: [],
				action: null,
				username: "",
				password: "",
			}
		}
	},
	computed: {
		...mapState({
			authUserPermissions: (state) => state.auth.userHasPermissions || {},
      stateAllMcrItemCat: (state) => state.mcr.allMcrItem || [],
      mcrHeader: (state) => state.mcr.mcrHeader || {},
      selectedMcrItem: (state) => state.mcr.selectedMcrItem,
      mapHardcodeMcr: (state) => state.mcr.mapHardcodeMcr || {},
			cataloguingFormConfig: (state) => state.mcr.cataloguingFormConfig,
      userHasRoles: (state) => state.auth.userHasRoles || [],
		}),
		mcrType() {
			const raw = (this.mcrHeader?.type || '').toLowerCase().replace(/\s+/g, '-');
			// mcrHeader.type bisa berupa kode (MCR003) atau slug (extend). Normalisasi kode → slug.
			const codeToSlug = {
				mcr001: 'create-new',
				mcr002: 'change-material',
				mcr003: 'extend',
				mcr004: 'block-unblock',
				mcr005: 'flag-unflag',
				mcr006: 'mrp',
				mcr007: 'mass-update-mrp',
			};
			return codeToSlug[raw] || raw;
		},
		isSpecialType() {
			return ['flag-unflag', 'block-unblock', 'mrp', 'update-price', 'mass-update-mrp'].includes(this.mcrType);
		},
		saveDraftLabel() {
			// Status 'draft' → "Back to Draft" (UserForm)
			// Status lain → "Save to Draft" (CataloguerForm)
			return this.mcrHeader.status === 'draft' ? 'Back to Draft' : 'Save to Draft';
		},
		isDraftStatus() {
			return this.mcrHeader.status === 'draft';
		},	
		isFromMyTask() {
			return this.$route.path.includes('my-task');
		},
		isFromEditSyncTask() {
			return this.$route.path.includes('edit-sync-task');
		},
		workflowReceivers() {
			return this.mcrHeader?.wc_workflow?.current_step?.data?.receivers || [];
		},
		requiresSapCredentials() {
			const receivers = this.workflowReceivers;
			const isAntamCompany = receivers.some(r => r.to === 'company' && r.values?.includes('ANTAM'));
			const isMaterialMgmt = receivers.some(r => r.to === 'role' && r.values?.includes('Material Management Managerial'));
			return isAntamCompany && isMaterialMgmt;
		},
		isAntamCompanyOrClient() {
			return this.companyCode === 'ANTAM' || this.clientCode === 'ANTAM';
		},
		isModalActionDisabled() {
			if (['sendBack', 'reject'].includes(this.modalFooter.action)) return !this.modalFooter.note;
			if (this.requiresSapCredentials) return !this.modalFooter.username || !this.modalFooter.password;
			return false;
		},
		isUserRole() {
			const allowedRoles = ['User', 'Inventory Control'];
			return this.userHasRoles.some(role => allowedRoles.includes(typeof role === 'string' ? role : role.name));
		},
		isCataloguerRole() {
			const allowedRoles = ['Cataloguer', 'Senior Cataloguer', 'Material Management Cataloguer'];
			return this.userHasRoles.some(role => allowedRoles.includes(typeof role === 'string' ? role : role.name));
		},
		isUserFormAccessedInCataloguerForm(){
			return ['FORM001D', 'FORM001E'].includes(this.cataloguingFormConfig?.form_type);
		},
		// Indikator apakah MCR sudah punya minimal 1 item. Baca dari form yang sedang
		// dirender (paling akurat & reaktif): special form → cek baris terisi (form selalu
		// menyiapkan 1 baris kosong, jadi rows.length saja tidak cukup); UserForm → cek
		// items lokal (store bisa stale setelah item ditambah); fallback → store allMcrItem.
		hasMcrItems() {
			const form = this.activeFormRef();
			if (form && Array.isArray(form.rows)) {
				return form.rows.some(r => r && (r.id || r.mcr_item_code || r.material_number));
			}
			if (form && Array.isArray(form.items)) {
				return form.items.length > 0;
			}
			return (this.stateAllMcrItemCat || []).length > 0;
		},
		showSaveDraftButton() {
			return !this.isFromMyTask && !this.isFromEditSyncTask;
		},
		showSaveDraftStayButton() {
			// Semua special type termasuk MCR007 (mass-update-mrp) menampilkan tombol 'Save Draft'
			// untuk menyimpan progres draft tanpa memulai workflow.
			return !this.isFromMyTask && !this.isFromEditSyncTask && this.isSpecialType;
		},
		showSendButton() {
			// Send hanya muncul kalau MCR sudah punya minimal 1 item (belum ada item → tombol disembunyikan)
			return !this.isFromMyTask && !this.isFromEditSyncTask;
		},
		showSaveDraftAntamButton() {
			return this.isUserRole && this.isUserFormAccessedInCataloguerForm;
		},
		workflowResult() {
			return this.mcrHeader?.wc_workflow?.current_step?.data?.result || {};
		},
		userRoleNames() {
			return this.userHasRoles.map(role => (typeof role === 'string' ? role : role.name));
		},
		hasWorkflowRoleReceiver() {
			return this.workflowReceivers.some(r => r.to === 'role' && r.values?.some(v => this.userRoleNames.includes(v)));
		},
		showRejectButton() {
			return this.isFromMyTask && 'reject' in this.workflowResult && this.hasWorkflowRoleReceiver;
		},
		showSendBackButton() {
			return this.isFromMyTask && 'send_back' in this.workflowResult && this.hasWorkflowRoleReceiver;
		},
		showApproveButton() {
			return this.isFromMyTask && 'approve' in this.workflowResult && this.hasWorkflowRoleReceiver;
		},			
		showSaveButtonForCataloguer() {
			return (this.isFromMyTask || this.isFromEditSyncTask) && !this.isUserFormAccessedInCataloguerForm && this.isCataloguerRole;
		},
	},
	mounted() {
		const userAuth = JSON.parse(localStorage.getItem('userAuth') || '{}');
		this.clientCode = userAuth?.user?.client_code || '';
		this.companyCode = userAuth?.user?.company_code || '';
		this.maybePrefetchTechnicalReviewerOptions();
	},
	watch: {
		// McrForm (parent) fetch mcrHeader secara async di mounted()-nya sendiri. Watch ini yang re-cek begitu
		// mcrHeader benar-benar sudah keisi (mcr.js commit object baru tiap kali fetch selesai).
		mcrHeader() {
			this.maybePrefetchTechnicalReviewerOptions();
		},
	},
	methods: {
		maybePrefetchTechnicalReviewerOptions() {
			// Guard `technicalReviewerOptionsPromise` supaya cuma fetch sekali walau dipanggil dari
			// mounted() maupun watch(mcrHeader) di atas.
			if (this.technicalReviewerOptionsPromise) return;
			if (this.showSendButton && this.isDraftStatus && !this.isSpecialType && this.companyCode === 'TIMAH') {
				this.technicalReviewerOptionsPromise = this.fetchTechnicalReviewerOptions();
			}
		},
		...mapActions("mcr", ["addValidationErrorAllMcrItemCat", "deleteErrorValidationAllMcrItemCat", "triggerRefresh", "storeAllMcrItem"]),
		async fetchTechnicalReviewerOptions() {
			try {
				const reviewerRes = await api(this, manageAccountService.list({ company_code: this.companyCode, role: "Technical Team" }), false);
				const reviewerList = reviewerRes?.data?.data || reviewerRes?.data || [];
				return (Array.isArray(reviewerList) ? reviewerList : []).reduce((acc, u) => {
					acc[u.username] = u.name ? `${u.username} - ${u.name}` : u.username;
					return acc;
				}, {});
			} catch (error) {
				return {};
			}
		},
		// Form yang sedang dirender (special form / UserForm), di layout mana pun:
		// - layout lama (McrForm): ref-nya langsung di parent → $refs.specialForm / $refs.userForm
		// - layout baru (New_McrForm → McrItem): form-nya ada di dalam McrItem, jadi diambil
		//   lewat activeForm() milik komponen itu.
		// Sengaja method (bukan computed): $refs tidak reaktif, computed-nya bisa nyangkut null.
		activeFormRef() {
			const parent = this.$parent;
			const direct = parent?.$refs?.specialForm || parent?.$refs?.userForm;
			if (direct) return direct;
			return parent?.$refs?.mcrItem?.activeForm?.() || null;
		},
		getSpecialFormService() {
			if (this.mcrType === 'flag-unflag') return flagUnflagFormService;
			if (this.mcrType === 'block-unblock') return blockUnblockFormService;
			if (this.mcrType === 'mrp') return mrpFormService;
			if (this.mcrType === 'mass-update-mrp') return massUpdateMrpFormService;
			if (this.mcrType === 'extend') return extendFormService;
			return null;
		},
		async saveSpecialForm() {
			const form = this.activeFormRef();
			// Validasi & payload diambil dari form yang sedang dirender (layout lama lewat
			// validateSpecialForm() parent, layout baru langsung ke method form-nya).
			const isValid = form?.validate ? form.validate() : (this.$parent?.validateSpecialForm?.() ?? true);
			if (!isValid) {
				this.$toastNotifPrime('warn', 'Validation', 'Please complete all required fields.');
				return false;
			}
			const service = this.getSpecialFormService();
			if (!service) {
				this.$toastNotifPrime('error', 'Error', `Save service for ${this.mcrType} is not registered.`);
				return false;
			}
			const id = this.$route.params.id;
			const rows = form?.getPayload ? form.getPayload() : (form?.rows ?? this.stateAllMcrItemCat);
			await api(this, service.save(id, { items: rows }), false);
			return true;
		},
		async saveDraft() {
			// Jika status draft (UserForm) → redirect ke list tanpa save
			if (this.isDraftStatus) {
				this.$router.push({ name: "Draft List" });
				return;
			}

			// Special types ('flag-unflag', 'block-unblock', 'mrp', 'extend', 'update-price') bypass cataloguer validation
			if (this.isSpecialType) {
				this.isLoadingSaveDraft = true;
				try {
					const saved = await this.saveSpecialForm();
					if (!saved) return;
					this.$router.push({ name: "Draft List" });
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingSaveDraft = false;
				}
				return;
			}

			setTimeout(() => { this.$router.push({ name: "Draft List" }) }, 500);
    },
		async saveDraftStay() {
			// Jika status draft (UserForm) → save special items only (no workflow start)
			if (this.isDraftStatus) {
				this.isLoadingSaveDraftStay = true;
				try {
					if (this.isSpecialType) {
						const saved = await this.saveSpecialForm();
						if (!saved) return;
					}
					this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
					this.triggerRefresh();
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingSaveDraftStay = false;
				}
				return;
			}

			// Special types bypass cataloguer validation
			if (this.isSpecialType) {
				this.isLoadingSaveDraftStay = true;
				try {
					const saved = await this.saveSpecialForm();
					if (!saved) return;
					this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
					this.triggerRefresh();
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingSaveDraftStay = false;
				}
				return;
			}

			// Jika status lain (CataloguerForm) → save draft
			this.deleteErrorValidationAllMcrItemCat();
			this.isLoadingSaveDraftStay = true;

			const type = "processed";
			const { validation, message } = this.validateAllTabsCatalogForm(type);
			if (!validation) {
				this.isLoadingSaveDraftStay = false;
				const tabs = message.split(',').map(tab => tab.trim());
				const tabsList = tabs.map(tab => `
					<div style="
						background: white;
						color: #2d3748;
						padding: 8px 14px;
						margin: 6px 0;
						border-radius: 6px;
						font-weight: 500;
						font-size: 0.85rem;
						border: 1px solid #e2e8f0; box-shadow: 0 1px 3px rgba(0,0,0,0.08);
						display: flex;
						align-items: center;
						gap: 6px;
					">
						<i class="pi pi-exclamation-circle" style="font-size: 0.85rem; color: #dc3545;"></i>
						<span>${tab}</span>
					</div>
				`).join('');

				this.$swal({
					icon: 'error',
					title: '<span style="font-size: 1.2rem; font-weight: 600; color: #2d3748; margin-top: -10px; display: block;">Validation Required</span>',
					html: `
						<div style="text-align: left; padding: 0 10px;">
							<p style="color: #4a5568; margin-bottom: 8px; font-size: 0.85rem;">Please complete the following tabs:</p>
							${tabsList}
						</div>
					`,
					confirmButtonText: '<i class="pi pi-check-circle"></i> Got It!',
					confirmButtonColor: '#667eea',
					padding: '0.5rem 1.5rem 1.5rem',
					backdrop: 'rgba(0,0,0,0.4)',
					customClass: {
						popup: 'swal-modern-popup',
						title: 'swal-modern-title',
						htmlContainer: 'swal-modern-html'
					}
				});
				return;
			}

			const payloadCat = this.preparePayload("cataloguer");
			try {
				const id = this.$route.params.id;
				if (!id) {
					this.$toastNotifPrime('warn', 'Validation', 'MCR ID not found. Please save the MCR first.');
					return;
				}

				// const response = await api(this, cataloguerFormService.saveDraft(id, { emcr_items: payloadCat }), false);
				await api(this, cataloguerFormService.saveDraft(id, { emcr_items: payloadCat }), false);
				this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
				this.triggerRefresh();
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this.isLoadingSaveDraftStay = false;
			}
		},
    validateAttachments() {
			const isAntam = this.companyCode === 'ANTAM';
			const emptyRows = (this.stateAllMcrItemCat || [])
				.map((item, index) => {
					const isEmpty = isAntam ? !Array.isArray(item?.cat_emcr_item_attachment) || item.cat_emcr_item_attachment.length === 0 : Array.isArray(item?.emcr_item_attachment) && item.emcr_item_attachment.length === 0;
					return isEmpty ? index + 1 : null;
				})
				.filter((row) => row !== null);
			if (emptyRows.length > 0) {
				this.$toastNotifPrime(
					'error',
					'Validation',
					`Attachment is required. Row ${emptyRows.join(', ')} ${emptyRows.length > 1 ? 'do' : 'does'} not have any attachment yet.`
				);
				return false;
			}
			return true;
		},
		validateItemsNotDraft() {
			const draftRows = (this.stateAllMcrItemCat || [])
				.map((item, index) => (item?.status === 'draft' ? index + 1 : null))
				.filter((row) => row !== null);
			if (draftRows.length > 0) {
				this.$toastNotifPrime(
					'error',
					'Validation',
					`MCR Item status must not be draft. Row ${draftRows.join(', ')} ${draftRows.length > 1 ? 'are' : 'is'} still in draft status.`
				);
				return false;
			}
			return true;
		},
    async send() {
			// Draft & non-draft (bukan special type) wajib punya minimal 1 attachment per item
			if (!this.isSpecialType && this.mcrType !== 'extend' && !this.validateAttachments()) return;

			// Jika status draft (UserForm) → start workflow
			if (this.isDraftStatus) {
				this.isLoadingCreate = true;
				try {
					// For special types, save items before starting workflow
					if (this.isSpecialType) {
						const saved = await this.saveSpecialForm();
						if (!saved) return;
					}

					// untuk dialog warning duplicate SPN saat akan send MCR
					if (!this.isSpecialType) {
						const duplRes = await api(this, userFormService.checkDuplSpnInUserForm(this.mcrHeader.mcr_code), false);
						const duplData = (duplRes && typeof duplRes === 'object' && duplRes.data && typeof duplRes.data === 'object') ? duplRes.data : duplRes;
						const duplicatedRows = Object.values(duplData || {}) .map((isDuplicate, idx) => (isDuplicate === true ? idx + 1 : null)) .filter((row) => row !== null);
						if (duplicatedRows.length > 0) {
							const confirmResult = await this.confirmDuplicateManufInUserForm(duplicatedRows);
							if (!confirmResult.isConfirmed) return;
						}
					}
					
					// untuk pilih user Technical Reviewer (khusus TIMAH) saat akan send MCR.
					let toUsername = null;
					if (!this.isSpecialType && this.companyCode === 'TIMAH') {
						const inputOptions = await (this.technicalReviewerOptionsPromise || this.fetchTechnicalReviewerOptions());

						const reviewerResult = await this.selectOptionDialog({
							title: "Choose User Technical Reviewer",
							inputOptions,
							inputPlaceholder: "Select a user",
							inputValidator: (value) => {
								if (!value) return "Please select a Technical Reviewer";
							},
						});
						if (!reviewerResult.isConfirmed) return;
						toUsername = reviewerResult.value;
					}

					const wfRes = await api(this, woApprovalService.getByModule('MCR'), false);
					const workflow_code = wfRes?.data?.code;
					if (!workflow_code) throw new Error('Workflow for MCR not found. Please contact administrator.');

					const payload = {
						code: workflow_code,
						key: this.mcrHeader.mcr_code,
						...(toUsername ? { to_username: toUsername } : {}),
					};
					// console.log("Sending MCR with payload:", payload);
					await api(this, woApprovalService.start(payload));
					this.$router.push({ name: "Draft List" });
				} catch (error) {
					this.$swal({
						icon: 'error',
						title: 'Error Sending MCR',
						text: error?.message || "Request failed with status code 500"
					});
				} finally {
					this.isLoadingCreate = false;
				}
				return;
			}

			// Special types bypass cataloguer validation
			if (this.isSpecialType) {
				this.isLoadingCreate = true;
				try {
					const saved = await this.saveSpecialForm();
					if (!saved) return;
					this.triggerRefresh();
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingCreate = false;
				}
				return;
			}

			// Non-draft, non-special type → open approve modal
			this.openFooterModal('approve');
    },
    openFooterModal(type) {
			if (type === 'approve' && this.workflowReceivers.some(r => r.to === 'role' && r.values?.includes('User')) && !this.validateAttachments()) {
				return;
			}
			// validateItemsNotDraft() cuma berlaku kalau (1) step workflow MCR ini memang step Cataloguer/Material Management Cataloguer, dan (2) user yang login juga punya salah satu role itu 
			const catalogerRoles = ['Cataloguer', 'Material Management Cataloguer'];
			const isCatalogerApprovalStep = this.workflowReceivers.some(r => r.to === 'role' && r.values?.some(v => catalogerRoles.includes(v)));
			const isCurrentUserCataloger = this.userHasRoles.some(role => catalogerRoles.includes(typeof role === 'string' ? role : role.name));
			if (type === 'approve' && isCatalogerApprovalStep && isCurrentUserCataloger && !this.validateItemsNotDraft()) {
				return;
			}
			this.modalFooter = {
				title: type === 'sendBack' ? 'Send Back' : type === 'reject' ? 'Reject' : 'Approve',
				action: type,
				note: '',
				errorMessage: [],
				username: '',
				password: '',
			};
			// 'approve' tidak lagi pakai data-bs-toggle di tombol (supaya modal tidak ikut terbuka kalau validateAttachments() atau this.validateItemsNotDraft() gagal di atas) — buka modal manual di sini.
			// 'sendBack'/'reject' tetap dibuka lewat data-bs-toggle di tombolnya masing-masing.
			if (type === 'approve') {
				this.$nextTick(() => {
					const modalEl = document.getElementById('modalFooterMcr');
					if (modalEl) {
						bootstrap.Modal.getOrCreateInstance(modalEl).show();
					}
				});
			}
		},
		closeModal() {
			this.modalFooter.note = '';
			this.modalFooter.errorMessage = [];
			this.modalFooter.username = '';
			this.modalFooter.password = '';
			this.$refs.closeModalFooterMcr?.click();
		},
		modalAction() {
			if (this.modalFooter.action === 'sendBack') {
				this.handleActionModal('isLoadingSendBack');
			} else if (this.modalFooter.action === 'reject') {
				this.handleActionModal('isLoadingReject');
			} else if (this.modalFooter.action === 'approve') {
				this.handleActionModal('isLoadingApprove');
			}
		},
		// Bangun teks "PS: ..." dari emcr_item_note tiap item di stateAllMcrItemCat (cancel/duplicate
		// yang masih pending, status === null) untuk disisipkan ke note approve/reject/sendBack.
		// Dibaca langsung dari store items (bukan dari state terpisah) supaya tetap akurat walau
		// halaman di-refresh.
		buildItemActionNotesText() {
			const cancelNotePrefix = 'This MCR Item has been canceled because';
			const uncancelNotePrefix = 'This MCR Item has been uncanceled because';
			const duplicateNotePrefix = 'This MCR Item has been marked as a duplicate because';
			const unDuplicateNotePrefix = 'This MCR Item has been unmarked as a duplicate because';
			const canceled = [];
			const duplicated = [];
			(this.stateAllMcrItemCat || []).forEach((item) => {
				const notes = item?.emcr_item_note;
				if (!Array.isArray(notes)) return;
				if (notes.some((n) => ((n.notes || '').startsWith(cancelNotePrefix) || (n.notes || '').startsWith(uncancelNotePrefix)) && n.status === null)) {
					canceled.push(item.mcr_item_code);
				}
				if (notes.some((n) => ((n.notes || '').startsWith(duplicateNotePrefix) || (n.notes || '').startsWith(unDuplicateNotePrefix)) && n.status === null)) {
					duplicated.push(item.mcr_item_code);
				}
			});
			const joinRows = (rows) => {
				if (rows.length === 0) return '';
				if (rows.length === 1) return `${rows[0]}`;
				if (rows.length === 2) return `${rows[0]} dan ${rows[1]}`;
				return `${rows.slice(0, -1).join(', ')}, dan ${rows[rows.length - 1]}`;
			};
			const lines = [];
			if (canceled.length > 0) {
				const rows = canceled.map((_, i) => i + 1);
				lines.push(`  - Telah melakukan status cancel di ${canceled.length} MCR Item, yaitu baris ke ${joinRows(rows)}`);
			}
			if (duplicated.length > 0) {
				const rows = duplicated.map((_, i) => i + 1);
				lines.push(`  - Telah melakukan status duplicated di ${duplicated.length} MCR Item, yaitu baris ke ${joinRows(rows)}`);
			}
			if (lines.length === 0) return '';
			return `Log: \n${lines.join('\n')}`;
		},
		async handleActionModal(loadingKey) {
			this[loadingKey] = true;
			try {
				await api(this, cataloguerFormService.saveNoteEmcr(this.mcrHeader.mcr_code, { action: 'update_status' }), false);
				const psText = this.buildItemActionNotesText();
				const note = psText ? `${this.modalFooter.note}${this.modalFooter.note ? '\n\n' : ''}${psText}` : this.modalFooter.note;
				const payload = {
					key: this.mcrHeader.mcr_code,
					note,
					// ...(loadingKey === 'isLoadingApprove' && this.isAntamCompanyOrClient && { force: 1 }),
					...(loadingKey === 'isLoadingApprove' && { force: 1 }),
					...(this.requiresSapCredentials && {
						username: this.modalFooter.username,
						password: this.modalFooter.password,
					}),
				};
				const serviceAction = this.modalFooter.action; // 'approve' | 'reject' | 'sendBack'
				await api(this, woApprovalService[serviceAction](payload));
				this.closeModal();
				this.$router.push({ name: 'My Task' });
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this[loadingKey] = false;
			}
		},
		async saveCatalog() {
			this.isLoadingSaveDraft = true;
			const payloadCat = this.preparePayloadSingleItem();
			this.deleteErrorValidationAllMcrItemCat();

			// Validasi dulu sebelum save
			let type = "processed";
			const { validation, message } = this.validateSingleMcrItem(type);
			if (!validation) {
				this.showTabValidationModal(message);
				this.isLoadingSaveDraft = false;
				return;
			}
			
			// // const payloadCat = this.preparePayloadSingleItem();
			try {
				const response = await api(this, cataloguerFormService.updatePerItem(payloadCat), false);

				const catEmcrPreviewDescriptions = {cat_short_description: response.data.cat_short_description, cat_po_vertical: response.data.cat_po_vertical, cat_po_horizontal: response.data.cat_po_horizontal}
				const updatedItem = {...this.selectedMcrItem, status: response.data.status, catalogued_by: response.data.catalogued_by, cat_emcr_preview_descriptions: catEmcrPreviewDescriptions, cat_short_description: response.data.cat_short_description, cat_po_vertical: response.data.cat_po_vertical, cat_po_horizontal: response.data.cat_po_horizontal };
				
				const updated = this.stateAllMcrItemCat.map((i) => i.mcr_item_code === updatedItem.mcr_item_code ? updatedItem : i);
				this.storeAllMcrItem(updated);
				this.$store.commit('mcr/setSelectedMcrItem', updatedItem);
				this.$toastNotifPrime('success', 'Success', 'Data saved successfully');
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this.isLoadingSaveDraft = false;
			}
		},
		// Modal "Please complete the following tabs: ..." — dipakai bareng oleh saveCatalog()
		// dan saveDraftPeritemFormUserAntam() supaya tampilannya konsisten.
		showTabValidationModal(message) {
			const tabs = message.split(',').map(tab => tab.trim());
			const tabsList = tabs.map(tab => `
				<div style="
					background: white;
					color: #2d3748;
					padding: 8px 14px;
					margin: 6px 0;
					border-radius: 6px;
					font-weight: 500;
					font-size: 0.85rem;
					border: 1px solid #e2e8f0; box-shadow: 0 1px 3px rgba(0,0,0,0.08);
					display: flex;
					align-items: center;
					gap: 6px;
				">
					<i class="pi pi-exclamation-circle" style="font-size: 0.85rem; color: #dc3545;"></i>
					<span>${tab}</span>
				</div>
			`).join('');
			this.$swal({
				icon: 'error',
				title: '<span style="font-size: 1.2rem; font-weight: 600; color: #2d3748; margin-top: -10px; display: block;">Validation Required</span>',
				html: `
					<div style="text-align: left; padding: 0 10px;">
						<p style="color: #4a5568; margin-bottom: 8px; font-size: 0.85rem;">Please complete the following tabs:</p>
						${tabsList}
					</div>
				`,
				confirmButtonText: '<i class="pi pi-check-circle"></i> Got It!',
				confirmButtonColor: '#667eea',
				padding: '0.5rem 1.5rem 1.5rem',
				backdrop: 'rgba(0,0,0,0.4)',
				customClass: {
					popup: 'swal-modern-popup',
					title: 'swal-modern-title',
					htmlContainer: 'swal-modern-html'
				}
			});
		},
		// Sama persis polanya dengan validateSingleMcrItem() (tab-grouped, dedup via Set,
		// dan tetap dispatch addValidationErrorAllMcrItemCat untuk inline error di form) —
		// (( BEDANYA )) cuma rules-nya: buildAntamDraftRulesForItem, field set lebih kecil karena
		// cuma menvalidasi field yang benar-benar dikirim buildAntamFormData().
		validateAntamDraftForm() {
			const item = this.selectedMcrItem;
			if (!item) return { validation: false, message: 'there is not the selecteed MCR item' };

			const rules = buildAntamDraftRulesForItem(this.mcrHeader.type);
			const { errors, tabErrors } = validateMcrItemCore(item, rules);
			const groupingErrorVal = new Set(
				Object.values(tabErrors).map((tabName) => `Tab ${tabName}`)
			);
			if (groupingErrorVal.size > 0) {
				const itemIndex = this.stateAllMcrItemCat.findIndex((i) => i.id === item.id);
				if (itemIndex !== -1) {
					const currentErrors = this.stateAllMcrItemCat.map(() => ({}));
					currentErrors[itemIndex] = errors;
					this.addValidationErrorAllMcrItemCat({ data: currentErrors });
				}
				return { validation: false, message: Array.from(groupingErrorVal).join(',') };
			}

			this.addValidationErrorAllMcrItemCat({ data: [] });
			return { validation: true, message: '' };
		},
		buildAntamFormData(item) {
			const normalize = (val) => {
				if (!val) return val;
				if (typeof val === 'object' && val !== null) {
					if (val.code) return val.code;
					if (val.warehouse_number) return val.warehouse_number;
					if (val.label && typeof val.label === 'string' && val.label.includes(' - ')) return val.label.split(' - ')[0];
					if (val.label) return val.label;
				}
				if (typeof val === 'string' && val.includes(' - ')) return val.split(' - ')[0];
				return val;
			};
			const fd = new FormData();
			const app = (key, val) => { if (val !== null && val !== undefined) fd.append(key, val); };
			const isMcr002 = this.mcrHeader.type === 'MCR002';

			app('id', item.id);
			app('cat_industry_sector', item.cat_industry_sector ?? '');
			app('cat_uom', normalize(item.cat_uom) ?? '');
			app('cat_material_type', item.cat_material_type ?? '');
			app('cat_material_group', item.cat_material_group ?? '');
			app('specification', item.specification ?? '');
			app('cat_lab_office', item.cat_lab_office ?? '');
			if (isMcr002) {
				app('material_number', item.material_number ?? '');
			}

			(item.cat_emcr_item_plants || []).forEach((plantRow, i) => {
				const mrp = (item.cat_emcr_item_plant || [])[i] || {};
				const purchasing = (item.cat_emcr_item_purchasings || [])[i] || {};
				app(`cat_plants[${i}][id]`, mrp.id ?? '');
				app(`cat_plants[${i}][mcr_item_code]`, mrp.mcr_item_code ?? '');
				app(`cat_plants[${i}][plant]`, plantRow.plant ?? '');
				if (!isMcr002) app(`cat_plants[${i}][mrp_profile]`, mrp.mrp_profile ?? '');
				app(`cat_plants[${i}][pur_group]`, purchasing.pur_group ?? '');
				if (!isMcr002) app(`cat_plants[${i}][mrp_group]`, mrp.mrp_group ?? '');
				if (!isMcr002) app(`cat_plants[${i}][mrp_type]`, mrp.mrp_type ?? '');
				if (!isMcr002) app(`cat_plants[${i}][lot_size]`, mrp.lot_size ?? '');
				app(`cat_plants[${i}][mrp_controller]`, mrp.mrp_controller ?? '');
				if (!isMcr002) app(`cat_plants[${i}][reorder_point]`, mrp.reorder_point ?? '');
				app(`cat_plants[${i}][planned_delivery]`, mrp.planned_delivery ?? '');
				app(`cat_plants[${i}][safety_stock]`, mrp.safety_stock ?? '');
				app(`cat_plants[${i}][service_level]`, mrp.service_level ?? '');
				if (!isMcr002) app(`cat_plants[${i}][avail_check]`, mrp.avail_check ?? '');
				// Field tambahan (dulu tidak dikirim sama sekali) — BE pakai delete+insert per baris,
				// jadi field yang tidak dikirim FE akan hilang dari DB meski user tidak menyentuhnya.
				app(`cat_plants[${i}][abc_indicator]`, mrp.abc_indicator ?? '');
				app(`cat_plants[${i}][period_in]`, mrp.period_in ?? '');
				app(`cat_plants[${i}][lotsize_costing]`, mrp.lotsize_costing ?? '');
				app(`cat_plants[${i}][procurement_type]`, mrp.procurement_type ?? '');
				app(`cat_plants[${i}][special_procurement_type]`, mrp.special_procurement_type ?? '');
				app(`cat_plants[${i}][min_lotsize]`, mrp.min_lotsize ?? '');
				app(`cat_plants[${i}][max_lotsize]`, mrp.max_lotsize ?? '');
				app(`cat_plants[${i}][max_stock]`, mrp.max_stock ?? '');
				app(`cat_plants[${i}][fixed_lot]`, mrp.fixed_lot ?? '');
				app(`cat_plants[${i}][stor_costs]`, mrp.stor_costs ?? '');
				app(`cat_plants[${i}][batch_management]`, mrp.batch_management ?? '');
				app(`cat_plants[${i}][profit_center]`, mrp.profit_center ?? '');
				app(`cat_plants[${i}][critical_part]`, mrp.critical_part ?? '');
				app(`cat_plants[${i}][sloc_for_ep]`, mrp.sloc_for_ep ?? '');
				app(`cat_plants[${i}][qm_material_auth]`, mrp.qm_material_auth ?? '');
				app(`cat_plants[${i}][sm_key]`, mrp.sm_key ?? '');
				app(`cat_plants[${i}][loading_group]`, mrp.loading_group ?? '');
				app(`cat_plants[${i}][gr_processing_time]`, mrp.gr_processing_time ?? '');
				app(`cat_plants[${i}][rounding_value]`, mrp.rounding_value ?? '');
				app(`cat_plants[${i}][co_product]`, mrp.co_product ?? '');
				app(`cat_plants[${i}][requirement_group]`, mrp.requirement_group ?? '');
				app(`cat_plants[${i}][individual_collective]`, mrp.individual_collective ?? '');
				app(`cat_plants[${i}][costing_lot_size]`, mrp.costing_lot_size ?? '');
				app(`cat_plants[${i}][inspection_type]`, mrp.inspection_type ?? '');
				app(`cat_plants[${i}][category_item]`, mrp.category_item ?? '');
				app(`cat_plants[${i}][unspsc_x_reference]`, mrp.unspsc_x_reference ?? '');
				app(`cat_plants[${i}][mind_id_number]`, mrp.mind_id_number ?? '');
				app(`cat_plants[${i}][review_date_inalum_data]`, mrp.review_date_inalum_data ?? '');
				app(`cat_plants[${i}][remark_inalum_data]`, mrp.remark_inalum_data ?? '');
				app(`cat_plants[${i}][sparepart_category]`, mrp.sparepart_category ?? '');
				app(`cat_plants[${i}][in_house_production]`, mrp.in_house_production ?? '');
				app(`cat_plants[${i}][backflush]`, mrp.backflush ?? '');
				app(`cat_plants[${i}][unit_of_issue]`, mrp.unit_of_issue ?? '');
				app(`cat_plants[${i}][production_storage_location]`, mrp.production_storage_location ?? '');
				app(`cat_plants[${i}][strategy_group]`, mrp.strategy_group ?? '');
				app(`cat_plants[${i}][consumption_mode]`, mrp.consumption_mode ?? '');
				app(`cat_plants[${i}][consumption_periode_forward]`, mrp.consumption_periode_forward ?? '');
				app(`cat_plants[${i}][consumption_periode_backward]`, mrp.consumption_periode_backward ?? '');
				app(`cat_plants[${i}][mix_mrp]`, mrp.mix_mrp ?? '');
				app(`cat_plants[${i}][selection_methode]`, mrp.selection_methode ?? '');
				app(`cat_plants[${i}][production_supervisor]`, mrp.production_supervisor ?? '');
				app(`cat_plants[${i}][production_scheduling_profile]`, mrp.production_scheduling_profile ?? '');
				app(`cat_plants[${i}][overdelivery_toler_limit]`, mrp.overdelivery_toler_limit ?? '');
				app(`cat_plants[${i}][underdelivery_toler_limit]`, mrp.underdelivery_toler_limit ?? '');
				app(`cat_plants[${i}][automation_po]`, mrp.automation_po ?? '');
				app(`cat_plants[${i}][plant_sp]`, mrp.plant_sp ?? '');
				app(`cat_plants[${i}][no_costing]`, mrp.no_costing ?? '');
				app(`cat_plants[${i}][variance_key]`, mrp.variance_key ?? '');
				app(`cat_plants[${i}][material_freight_group]`, mrp.material_freight_group ?? '');
			});
			
			(item.cat_emcr_item_plants || []).forEach((pr, i) => {
				const val = (item.cat_emcr_item_valuation || [])[i] || {};
				app(`cat_valuations[${i}][id]`, val.id ?? '');
				app(`cat_valuations[${i}][mcr_item_code]`, val.mcr_item_code ?? '');
				app(`cat_valuations[${i}][valuation_area]`, pr.plant ?? '');
				app(`cat_valuations[${i}][valuation_type]`, val.valuation_type ?? '');
				app(`cat_valuations[${i}][valuation_class]`, val.valuation_class ?? '');
				app(`cat_valuations[${i}][price_control]`, val.price_control ?? '');
				app(`cat_valuations[${i}][std_price]`, val.std_price ?? '');
				app(`cat_valuations[${i}][valuation_category]`, val.valuation_category ?? '');
				app(`cat_valuations[${i}][moving_price]`, val.moving_price ?? '');
				app(`cat_valuations[${i}][price_unit]`, val.price_unit ?? '');
				app(`cat_valuations[${i}][ml_active]`, val.ml_active ?? '');
				app(`cat_valuations[${i}][ml_settle]`, val.ml_settle ?? '');
				app(`cat_valuations[${i}][qty_struct]`, val.qty_struct ?? '');
				app(`cat_valuations[${i}][overhead_group]`, val.overhead_group ?? '');
				app(`cat_valuations[${i}][price_reference]`, val.price_reference ?? '');
				app(`cat_valuations[${i}][price_determination]`, val.price_determination ?? '');
				app(`cat_valuations[${i}][original_material]`, val.original_material ?? '');
			});

			(item.cat_emcr_item_attachment || []).forEach((att) => {
				if (!att) return;
				const isFile = (typeof File !== 'undefined' && att instanceof File) || (typeof Blob !== 'undefined' && att instanceof Blob);
				if (isFile) fd.append('cat_attachments[]', att, att.name || 'attachment');
			});

			(item.cat_emcr_item_manufacturer || []).forEach((mf, i) => {
				app(`cat_manufacturers[${i}][id]`, mf.id ?? '');
				app(`cat_manufacturers[${i}][mcr_item_code]`, mf.mcr_item_code ?? '');
				app(`cat_manufacturers[${i}][mpn_number]`, mf.mpn_number ?? '');
				app(`cat_manufacturers[${i}][manufacture]`, mf.manufacture ?? '');
				app(`cat_manufacturers[${i}][manufacture_ref]`, mf.manufacture_ref ?? '');
				app(`cat_manufacturers[${i}][manufacture_ref_description]`, mf.manufacture_ref_description ?? '');
				app(`cat_manufacturers[${i}][source_type]`, mf.source_type ?? '');
				app(`cat_manufacturers[${i}][manref_type]`, mf.manref_type ?? '');
				app(`cat_manufacturers[${i}][position]`, mf.position ?? '');
				app(`cat_manufacturers[${i}][spn]`, mf.spn ?? '');
				app(`cat_manufacturers[${i}][valid_until]`, mf.valid_until ?? '');
				app(`cat_manufacturers[${i}][valid_start]`, mf.valid_start ?? '');
				app(`cat_manufacturers[${i}][notes]`, mf.notes ?? '');
			});

			// if (!isMcr002) {
				// Baris yang field esensialnya kosong (belum diisi user) sengaja TIDAK dikirim
				// sama sekali — BE menolak object dengan field required kosong (mis.
				// cat_warehouses.0.warehouse_number required), tapi array kosong [] aman.
				// Index FormData dibuat ulang per section (bukan reuse index plant) supaya
				// tidak ada gap di antara cat_locations[0], cat_locations[1], dst.
				let locIdx = 0;
				(item.cat_emcr_item_plants || []).forEach((plantRow, i) => {
					const loc = (item.cat_emcr_item_location || [])[i] || {};
					if (isCatFieldEmpty(loc.location)) return;
					app(`cat_locations[${locIdx}][id]`, loc.id ?? '');
					app(`cat_locations[${locIdx}][mcr_item_code]`, loc.mcr_item_code ?? '');
					app(`cat_locations[${locIdx}][plant]`, plantRow.plant ?? '');
					app(`cat_locations[${locIdx}][location]`, loc.location ?? '');
					app(`cat_locations[${locIdx}][bin]`, loc.bin ?? '');
					app(`cat_locations[${locIdx}][stock]`, loc.stock ?? '');
					locIdx++;
				});

				let whIdx = 0;
				(item.cat_emcr_item_plants || []).forEach((plantRow, i) => {
					const wh = (item.cat_emcr_item_warehouses || [])[i] || {};
					if (isCatFieldEmpty(wh.warehouse_number)) return;
					app(`cat_warehouses[${whIdx}][id]`, wh.id ?? '');
					app(`cat_warehouses[${whIdx}][mcr_item_code]`, wh.mcr_item_code ?? '');
					app(`cat_warehouses[${whIdx}][plant]`, plantRow.plant ?? '');
					app(`cat_warehouses[${whIdx}][warehouse_number]`, wh.warehouse_number ?? '');
					app(`cat_warehouses[${whIdx}][stock_removal]`, wh.stock_removal ?? '');
					app(`cat_warehouses[${whIdx}][stock_replacement]`, wh.stock_replacement ?? '');
					app(`cat_warehouses[${whIdx}][storage_section_ind]`, wh.storage_section_ind ?? '');
					whIdx++;
				});

				let stIdx = 0;
				(item.cat_emcr_item_plants || []).forEach((plantRow, i) => {
					const wh = (item.cat_emcr_item_warehouses || [])[i] || {};
					const st = (item.cat_emcr_item_storage_types || [])[i] || {};
					if (isCatFieldEmpty(st.storage_type)) return;
					app(`cat_storage_types[${stIdx}][id]`, st.id ?? '');
					app(`cat_storage_types[${stIdx}][mcr_item_code]`, st.mcr_item_code ?? '');
					app(`cat_storage_types[${stIdx}][plant]`, plantRow.plant ?? '');
					app(`cat_storage_types[${stIdx}][warehouse_number]`, wh.warehouse_number ?? '');
					app(`cat_storage_types[${stIdx}][storage_type]`, st.storage_type ?? '');
					app(`cat_storage_types[${stIdx}][storage_bin]`, st.storage_bin ?? '');
					stIdx++;
				});
			// }

			return fd;
		},
		async saveDraftPeritemFormUserAntam() {
			this.deleteErrorValidationAllMcrItemCat();
			this.isLoadingSaveDraftFormUserAntam = true;

			const { validation, message } = this.validateAntamDraftForm();
			if (!validation) {
				this.isLoadingSaveDraftFormUserAntam = false;
				this.showTabValidationModal(message);
				return;
			}

			try {
				const item = this.selectedMcrItem;
				if (!item) return;
				const fd = this.buildAntamFormData(item);
				await api(this, userFormService.updateFromCataloguerForm(item.id, fd), false);
				// const response = await api(this, userFormService.updateFromCataloguerForm(item.id, fd), false);
				// const updatedItem = response.data;
				// updatedItem.index = item.index;
				// this.normalizeItem(updatedItem);
				// const updated = this.stateAllMcrItemCat.map((i) => i.id === updatedItem.id ? updatedItem : i);
				// this.storeAllMcrItem(updated);
				// this.$store.commit('mcr/setSelectedMcrItem', updatedItem);
				this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this.isLoadingSaveDraftFormUserAntam = false;
			}
		},
		handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          const allErrors = [];
          
          for(const key in errorData) {    
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const messages = Array.isArray(errorData[key]) ? errorData[key] : [errorData[key]];
              messages.forEach(message => {
                allErrors.push(`• ${key}: ${message}`);
              });
            } 
          }
          
          if (allErrors.length > 0) {
            const errorMessage = allErrors.join('\n');
            this.$toastNotifPrime('error', error.response.data.message, errorMessage);
            return;
          }
        }
        
        // Fallback for 500 error
        if (error.response?.status == 500) {
          this.$toastNotifPrime('error', 'Error', 'Failed to save MCR');
          return;
        }
        
        // Other errors
        const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
        this.$toastNotifPrime('error', 'Error', errorMessage);
      } else {
        this.$toastNotifPrime('error', 'Error', error.message || 'An unexpected error occurred');
      }
    },
		validateAllTabsCatalogForm(type) {
			if (!['processed'].includes(type)) return { validation: true, message: '' };
			const isThereTabError = [];
			const allErrorValCat = this.stateAllMcrItemCat.map((item, indx) => {
				if (!isThereTabError[indx]) isThereTabError[indx] = {};
				const rules = buildDynamicRulesForItem(item, this.companyCode, this.mcrHeader.type);
				if (!rules) return {};
				const { errors, tabErrors } = validateMcrItemCore(item, rules);
				Object.assign(isThereTabError[indx], tabErrors);
				return errors;
			});
			const groupingErrorVal = new Set();
			isThereTabError.forEach((obj) => {
				if (Object.keys(obj).length > 0) {
					Object.values(obj).forEach((tabName) => groupingErrorVal.add(`Tab ${tabName}`));
				}
			});
			if (groupingErrorVal.size > 0) {
				this.addValidationErrorAllMcrItemCat({ data: allErrorValCat });
				return { validation: false, message: `${Array.from(groupingErrorVal).join(',')}` };
			}
			this.addValidationErrorAllMcrItemCat({ data: [] });
			return { validation: true, message: '' };
		},
		validateSingleMcrItem(type) { 
			if (!['processed'].includes(type)) return { validation: false, message: 'the MCR is not MCR Processed' };
			if (!this.selectedMcrItem) return { validation: false, message: 'there is not the selecteed MCR item' };

			// buat rules validasi
			// console.log("selectedMcrItem", JSON.stringify(this.selectedMcrItem))
			const rules = buildDynamicRulesForItem(this.selectedMcrItem, this.companyCode, this.mcrHeader.type);
			if (!rules) {
				this.addValidationErrorAllMcrItemCat({ data: [] });
				return { validation: true, message: '' };
			}
			// mulai validasi
			const { errors, tabErrors } = validateMcrItemCore(this.selectedMcrItem, rules);
			const groupingErrorVal = new Set(
				Object.values(tabErrors).map((tabName) => `Tab ${tabName}`)
			);
			if (groupingErrorVal.size > 0) {
				// Update error hanya untuk slot item yang sedang dipilih
				const itemIndex = this.stateAllMcrItemCat.findIndex((i) => i.id === this.selectedMcrItem.id);
				if (itemIndex !== -1) {
					const currentErrors = this.stateAllMcrItemCat.map(() => ({}));
					currentErrors[itemIndex] = errors;
					this.addValidationErrorAllMcrItemCat({ data: currentErrors });
				}
				return { validation: false, message: Array.from(groupingErrorVal).join(',') };
			}

			this.addValidationErrorAllMcrItemCat({ data: [] });
			return { validation: true, message: '' };
		},
		preparePayload(catOrUser) {
			let allFormDataCat = [];
			const normalize = val => {
				if (!val) return val;
				
				// Handle object
				if (typeof val === 'object' && val !== null) {
					if (val.code) return val.code;
					if (val.warehouse_number) return val.warehouse_number;
					if (val.label && typeof val.label === 'string' && val.label.includes(" - ")) {
						return val.label.split(" - ")[0];
					}
					if (val.label) return val.label;
				}
				
				// Handle string - check if there's a detail object first
				// This handles SearchableSelect fields that store label in field and object in field_detail
				if (typeof val === 'string') {
					// Try to find detail object (e.g., item_cat_group_detail for item_cat_group)
					// This is handled by checking the parent context, but we can't access it here
					// So we just return the string as-is and rely on the mapping to use detail objects
					return val;
				}
				
				return val;
			};

			if (catOrUser === 'cataloguer') {
				allFormDataCat = this.stateAllMcrItemCat.map(y => {
					const payloadMnf = y.cat_emcr_item_manufacturer.map(mf => ({
						mpn_number: mf.mpn_number ?? null,
						manufacture: mf.catalog_manufacture?.code || mf.manufacture,
						manufacture_ref: mf.manufacture_ref,
						manufacture_ref_description: mf.manufacture_ref_description,
						source_type: normalize(mf.source_type),
						manref_type: normalize(mf.manref_type),
						position: mf.position ? String(mf.position) : null,
						spn: mf.spn,
						valid_until: mf.valid_until,
						notes: mf.notes
					})); //ada ubah
					const payloadEqp = y.cat_emcr_item_equipment.map(eq => ({
						client: this.clientCode,
						plant: normalize(eq.plant),
						equipment: eq.equipment_detail?.code || eq.equipment,
						qty_installed: String(eq.qty_installed ?? '')
					}));
					const payloadPlant = y.cat_emcr_item_plants.map(pl => ({
						client: this.clientCode,
						plant: normalize(pl.plant),
						period_in: pl.period_in || null,
						unit_of_issue: pl.unit_of_issue || null
					})); //ada ubah
					const payloadKeword = y.cat_emcr_item_keyword.map(kw => ({ keyword: kw.keyword }));
					const payloadLoc = y.cat_emcr_item_location.map(lc => ({
						client: this.clientCode,
						plant: normalize(lc.plant),
						location: lc.location_detail?.code || lc.location,
						bin: lc.bin,
						stock: lc.stock != null ? String(lc.stock) : null
					}));
					const payloadVal = y.cat_emcr_item_valuation.map(vl => ({
						client: this.clientCode,
						valuation_area: normalize(vl.valuation_area),
						valuation_category: normalize(vl.valuation_category),
						valuation_type: normalize(vl.valuation_type),
						price_control: normalize(vl.price_control),
						moving_price: vl.moving_price ? String(vl.moving_price) : null,
						std_price: vl.std_price ? String(vl.std_price) : null,
						price_unit: vl.price_unit ? String(vl.price_unit) : null,
						price_reference: vl.price_reference != null ? String(vl.price_reference) : null,
						valuation_class: normalize(vl.valuation_class),
						ml_active: vl.ml_active,
						ml_settle: vl.ml_settle ? String(vl.ml_settle) : null,
						qty_struct: vl.qty_struct,
						overhead_group: vl.overhead_group ?? '',
						price_determination: vl.price_determination
					})); //ada ubah
					const payloadCharVal = y.cat_emcr_item_characteristic_value.map(cv => ({
						cin_code: cv.cin_code,
						cinv_code: cv.cinv_code ?? null,
						view: cv.view ?? null,
						is_multiple: cv.is_multiple ?? null,
						classification_type: ""
					})); //ada ubah
					const payloadAttach = y.cat_emcr_item_attachment
						.filter(att => att.file_code) // Send all attachments with file_code
						.map(att => ({ file_code: att.file_code}));
					const payloadSales = (y.cat_emcr_item_sales || []).map(sl => ({
						acc_ass_group: normalize(sl.acc_ass_group),
						sales_organization: normalize(sl.sales_organization),
						distr_channel: normalize(sl.distr_channel),
						cash_discount: sl.cash_discount,
						item_cat_code: sl.item_cat_group,
						material_statistic_code: sl.material_statistic_code,
						division: sl.division,
						material_price: sl.material_price,
						client: this.clientCode,
						delivering_plant: sl.delivering_plant,
						sales_unit: sl.sales_unit,
						commission_group: sl.commission_group,
						departure_country: sl.departure_country,
						tax_category: sl.tax_category,
						tax_classification: sl.tax_classification,
						gen_item_cat_grp: sl.gen_item_cat_grp
					})); //ada ubah
					const payloadWarehouses = (y.cat_emcr_item_warehouses || []).map(wh => ({
						warehouse_number: wh.warehouse_number,
						client: this.clientCode,
						plant: wh.plant,
						stock_removal: normalize(wh.stock_removal),
						stock_replacement: normalize(wh.stock_replacement),
						storage_section_ind: normalize(wh.storage_section_ind)
					})); //ada ubah
					const payloadStorageTypes = (y.cat_emcr_item_storage_types || []).map(st => ({
						client: this.clientCode,
						plant: normalize(st.plant),
						warehouse_number: normalize(st.warehouse_number),
						storage_type: normalize(st.storage_type),
						storage_bin: normalize(st.storage_bin)
					})); //ada ubah
					const payloadSalesGenPlants = (y.cat_emcr_item_sale_general_plants || []).map(sgp => ({
						client: this.clientCode,
						plant: sgp.plant,
						trans_grp: sgp.trans_grp,
						batch_management: sgp.batch_management,
						loading_group: sgp.loading_group,
						profit_center: sgp.profit_center
					}));
					const payloadMrps = (y.cat_emcr_item_plant || []).map(pl => ({
						client: this.clientCode,
						plant: normalize(pl.plant),
						sparepart_category: pl.sparepart_category,
						mrp_type: normalize(pl.mrp_type),
						mrp_controller: normalize(pl.mrp_controller),
						mrp_group: pl.mrp_group,
						lot_size: pl.lot_size,
						reorder_point: String(pl.reorder_point ?? ''),
						max_stock: String(pl.max_stock ?? ''),
						abc_indicator: normalize(pl.abc_indicator),
						min_lotsize: String(pl.min_lotsize ?? ''),
						max_lotsize: String(pl.max_lotsize ?? ''),
						rounding_value: String(pl.rounding_value ?? ''),
						fixed_lot: String(pl.fixed_lot ?? ''),
						safety_stock: String(pl.safety_stock ?? ''),
						sloc_for_ep: normalize(pl.sloc_for_ep),
						procurement_type: normalize(pl.procurement_type),
						co_product: pl.co_product,
						avail_check: normalize(pl.avail_check),
						requirement_group: normalize(pl.requirement_group),
						individual_collective: pl.individual_collective,
						special_procurement_type: normalize(pl.special_procurement_type),
						planned_delivery: String(pl.planned_delivery ?? ''),
						in_house_production: String(pl.in_house_production ?? ''),
						gr_processing_time: String(pl.gr_processing_time ?? ''),
						sm_key: normalize(pl.sm_key),
						backflush: pl.backflush,
						strategy_group: pl.strategy_group,
						consumption_mode: pl.consumption_mode,
						consumption_periode_forward: String(pl.consumption_periode_forward ?? ''),
						consumption_periode_backward: String(pl.consumption_periode_backward ?? ''),
						mix_mrp: pl.mix_mrp,
						selection_methode: pl.selection_methode,
						service_level: String(pl.service_level ?? '')
					}));
					const payloadWorkSchedViews = [];
					// const payloadWorkSchedViews = (y.cat_emcr_item_work_schedulling_views || []).map(wsv => ({
					// 	client: this.clientCode,
					// 	plant: normalize(wsv.plant),
					// 	production_supervisor: wsv.production_supervisor,
					// 	production_scheduling_profile: wsv.production_scheduling_profile,
					// 	production_storage_location: wsv.production_storage_location,
					// 	underdelivery_toler_limit: wsv.underdelivery_toler_limit,
					// 	overdelivery_toler_limit: wsv.overdelivery_toler_limit
					// }));
					const payloadPurchasing = (y.cat_emcr_item_purchasings || []).map(pcs => ({
						client: this.clientCode,
						plant: normalize(pcs.plant),
						pur_group: normalize(pcs.pur_group) || "",
						order_unit: pcs.order_unit,
						critical_part: pcs.critical_part,
						automation_po: pcs.automation_po,
						plant_sp: pcs.plant_sp
					}));
					const payloadCostView = (y.cat_emcr_item_costing_views || []).map(cvs => ({
						client: this.clientCode,
						plant: normalize(cvs.plant),
						no_costing: cvs.no_costing,
						variance_key: cvs.variance_key,
						qty_struct: cvs.qty_struct,
						original_material: cvs.original_material,
						overhead_group: cvs.overhead_group,
						costing_lot_size: cvs.costing_lot_size != null ? String(cvs.costing_lot_size) : null
					}));
					const payloadQualManag = (y.cat_emcr_item_inspection || []).map(ins => ({
						client: this.clientCode,
						plant: normalize(ins.plant),
						inspect_with_task_list: ins.inspect_with_task_list,
						inspection_type: ins.inspection_type,
						post_to_qi_stock: ins.post_to_qi_stock,
						automatic_assignment: ins.automatic_assignment,
						inspect_charcs: ins.inspect_charcs,
						inspect_percentage: ins.inspect_percentage != null ? String(ins.inspect_percentage) : null,
						skips_allowed: ins.skips_allowed,
						q_score_procedure: ins.q_score_procedure,
						inspect_type_matl_active: ins.inspect_type_matl_active,
						preferred_insp_type: ins.preferred_insp_type
					}));
					const payloadInsText = (y.cat_emcr_item_inspection_text || []).map(it => ({
						language: it.language,
						inspection_text: it.inspection_text
					}));
					const payloadDataOne = (y.cat_emcr_inalum_datas || []).map(ido => ({
						client: this.clientCode,
						plant: normalize(ido.plant),
						category_item: ido.category_item,
						unspsc_x_reference: ido.unspsc_x_reference,
						mind_id_number: ido.mind_id_number,
						review_date_inalum_data: ido.review_date_inalum_data,
						remark_inalum_data: ido.remark_inalum_data
					}));
					const payloadAltUom = (y.cat_emcr_item_alternative_uom || []).map(alt => ({
						client: this.clientCode,
						alternative_unit_of_measure: alt.alternative_unit_of_measure,
						numerator: alt.numerator,
						denumerator: alt.denumerator,
						source_field: alt.source_field
					}));

					return {
						id: y.id,
						mcr_code: this.mcrHeader.mcr_code,
						mcr_item_code: y.mcr_item_code,
						client: this.clientCode,
						cat_inc: y.catalog_inc?.inc || (typeof y.cat_inc === 'string' && y.cat_inc.includes(' - ') ? y.cat_inc.split(' - ')[0] : y.cat_inc),
						cat_item_type: normalize(y.cat_item_type),
						cat_uom: y.catalog_uom?.code || (typeof y.cat_uom === 'string' && y.cat_uom.includes(' - ') ? y.cat_uom.split(' - ')[0] : y.cat_uom),
						cat_material_type: normalize(y.cat_material_type),
						cat_material_group: normalize(y.cat_material_group),
						cat_old_material_number: y.cat_old_material_number,
						cat_industry_sector: y.cat_industry_sector,
						cat_ext_material_group: y.cat_ext_material_group,
						cat_notes: y.cat_notes,
						cat_short_description: y.cat_short_description,
						cat_po_vertical: y.cat_po_vertical,
						cat_po_horizontal: y.cat_po_horizontal,
						cat_product_hierarchy: y.cat_product_hierarchy,
						cat_standard_description: y.cat_standard_description,
						cat_currency: y.cat_currency,
						cat_price_unit: y.cat_price_unit != null ? String(y.cat_price_unit) : null,
						cat_authorization_group: y.cat_authorization_group,
						cat_net_weight: y.cat_net_weight,
						cat_weight_unit: y.cat_weight_unit,
						cat_expiration_date: y.cat_expiration_date,
						cat_manufacture_part_profile: (Array.isArray(payloadMnf) && payloadMnf.length > 0) ? this.mapHardcodeMcr?.manufacture_part_profile || "" : y.cat_manufacture_part_profile || "",
						cat_purchasing_val_key: y.cat_purchasing_val_key,
						// cat_group_class: normalize(y.cat_group_class),
						// cat_kimap: y.cat_kimap,
						// cat_division: y.cat_division,
						// cat_gen_item_cat_grp: typeof y.cat_gen_item_cat_grp === 'object' ? y.cat_gen_item_cat_grp?.label || y.cat_gen_item_cat_grp?.code : y.cat_gen_item_cat_grp,
						// cat_batch_management: y.cat_batch_management,
						// cat_trans_grp: y.cat_trans_grp,
						cat_emcr_manufacturers: payloadMnf,
						cat_emcr_equipments: payloadEqp,
						cat_emcr_plants: payloadPlant,
						cat_emcr_keywords: payloadKeword,
						cat_emcr_locations: payloadLoc,
						cat_emcr_accountings: payloadVal,
						cat_emcr_characteristic_values: payloadCharVal,
						cat_emcr_attachments: payloadAttach,
						cat_emcr_sales: payloadSales,
						cat_emcr_warehouses: payloadWarehouses,
						cat_emcr_storage_types: payloadStorageTypes,
						cat_emcr_sales_general_plants: payloadSalesGenPlants,
						cat_emcr_mrps: payloadMrps,
						cat_emcr_work_schedulling_views: payloadWorkSchedViews,
						cat_emcr_purchasings: payloadPurchasing,
						cat_emcr_costing_views: payloadCostView,
						cat_emcr_quality_managements: payloadQualManag,
						cat_emcr_inspection_texts: payloadInsText,
						cat_emcr_inalum_datas: payloadDataOne,
						cat_emcr_alternative_uoms: payloadAltUom,
					};
				})
			}

			return allFormDataCat
    },
		preparePayloadSingleItem() {
			if (!this.selectedMcrItem) return null;
			return normalizeItemPayload(this.selectedMcrItem, this.clientCode, this.mcrHeader.mcr_code, this.mapHardcodeMcr, this.companyCode, this.mcrHeader.type);
		},
	}
}
</script>
<style scoped>
.btn:disabled {
	color: white !important;
}
</style>
